module.exports = __webpack_public_path__ + "img/wechatQRcode.278c5f87.png";